module.exports = __webpack_public_path__ + "media/hatching.aeb37803.mp4";